module.exports = __webpack_public_path__ + "media/images/ping/green-837e92b09d1e71e0508449951a3607fe.png";